///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Namespaces
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.thoughtspot = abcsetup.thoughtspot || {};
abcsetup.thoughtspot.invitations = abcsetup.thoughtspot.invitations || {};
abcsetup.thoughtspot.invitations.workflow = abcsetup.thoughtspot.invitations.workflow || {};




///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Methods
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.thoughtspot.invitations.workflow = {
    // Variables
    canvas: null,
    signaturePad: null,

    init: function() {
        abcsetup.setTitle('ThoughtSpot Registrations');

        // Clear signature button clicked
        $(document).on('click', '#clear-signature', function () {
            $('.signature-pad-alert').addClass('d-none');
            abcsetup.thoughtspot.invitations.workflow.signaturePad.clear();
        });

        // The form was submitted
        $(document).on('submit', '#workflow_form', function () {
            return abcsetup.thoughtspot.invitations.workflow.submit();
        });

        // Keep track of which submit button was clicked
        $("form button[type=submit]").click(function() {
            $("button[type=submit]", $(this).parents("form")).removeAttr("clicked");
            $(this).attr("clicked", "true");
        });

        if ($('#signature-pad').length) {
            this.canvas = document.getElementById('signature-pad');
            //this.signaturePad = new SignaturePad(this.canvas);
            this.signaturePad = new SignaturePad.default(this.canvas);

            window.onresize = abcsetup.thoughtspot.invitations.workflow.resizeCanvas;
            abcsetup.thoughtspot.invitations.workflow.resizeCanvas();
        }

        $(this.canvas).on('mouseup', () => {
            let valid = abcsetup.validateSignaturePad('signature-pad', 'Please enter a valid signature.');

            $('button[name="form_action"]').attr('disabled', (valid === false));
        });
    },

    // Adjust canvas coordinate space taking into account pixel ratio to make it look crisp on mobile devices
    // This also causes canvas to be cleared
    resizeCanvas: function() {
        // When zoomed out to less than 100% some browsers report devicePixelRatio as < 1 and only part of the canvas is cleared
        var ratio =  Math.max(window.devicePixelRatio || 1, 1);
        this.canvas.width = this.canvas.offsetWidth * ratio;
        this.canvas.height = this.canvas.offsetHeight * ratio;
        this.canvas.getContext("2d").scale(ratio, ratio);
    },

    /**
     *
     */
    submit() {
        // Get the value of the submit button that was clicked
        var val = $("button[type=submit][clicked=true]").val();

        // We have a signature
        if ($('#signature-pad').length && val === 'approve') {
            // The signature is empty - throw an error
            if (this.signaturePad.isEmpty()) {
                abcsetup.alerts.show('Error Approving Registration', 'Please sign your name in the signature pad');
                return false;
            }

            // Save the signature as a PNG and append it to the form
            var data = this.signaturePad.toDataURL('image/png');
            $('#workflow_form').find('#signature').remove();
            $('#workflow_form').append('<input type="hidden" name="signature" id="signature" value="' + data + '">');
        }

        return true;
    },
}
